import React from 'react';
import card from '../../assets/images/card.png';
import VoteValue from '../VoteValue';
import styles from './FrontCard.module.css';

const FrontCard = ({ value, className }) => {
  return (
    <div className={`${styles.cardFrontContainer} ${className}`}>
      <img className={styles.cardFront} src={card} alt="Card Front" />
      <VoteValue
        value={value}
        className={`${styles.vote} ${styles.voteValue}`}
      />
    </div>
  );
};

export default FrontCard;
